import { Box, Button, FormControl, FormControlLabel, Grid, Grid2, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Radio, RadioGroup, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import TokenError from '../tokenError';
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import config from '../../config/config.js';
import BlockImg from '../../assets/images/blockImg.svg';
import deleteImg from '../../assets/images/deleteImg.svg';
import CloseIcon from '@mui/icons-material/Close';
import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import threeDots from '../../assets/images/threeDots.svg';
import { Label } from "flowbite-react";
import importArrowIcon from '../../assets/images/importArrow.svg';
import exportCSVIcon from '../../assets/icons/exportCsvBlack.svg';
import { CSVLink } from "react-csv";

const Chassis = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('chassis_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [open, setOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(''); // 'block' or 'delete'
    const [actionReason, setActionReason] = useState('');
    const [isReasonError, setIsReasonError] = useState(false);

    const [chassisId, setChassisId] = useState('');
    const [chassisNo, setChassisNo] = useState('');
    const [chassisProvider, setChassisProvider] = useState('');
    const [address, setAddress] = useState('');
    const [plateNo, setPlateNo] = useState('');
    const [type, setType] = useState('');
    const [phone, setPhone] = useState('');
    const [contractType, setContractType] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [vendors, setVendors] = useState([]);
    const [description, setDescription] = useState('');
    const fileInputRef = useRef(null);
    const [allData, setAllData] = useState([]);
    const [showTemplateButton, setShowTemplateButton] = useState(false);
    const [formErrors, setFormErrors] = useState({
        chassisNo: false,
        plateNo: false, 
        chassisProvider: false,
        type: false,
        description: false
    });
    
    const inputRef = useRef(null); 

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }
    const fetchChassisData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_chassis_details';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Sort data in descending order by chassis_id before setting it
                const sortedData = [...response.data].sort((a, b) => {
                    if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
                    if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
                    return 0;
                });
                setRows(sortedData);
                const formattedData = formatDataForCSV(sortedData);
                setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchChassisData();
        fetchVendorsData();
    },[cityFilter])

    const handleOpenAddChassis = () => {
        console.log('openig add');
        setEditMode(false);
        setOpen(true);
        setChassisId('');
        setChassisNo('');
        setChassisProvider('');
        setPlateNo('');
        // setContractType('');
        // setPhone('');
        // setEmail('');
        // setAddress('');
        setType('');
        setDescription('');
        // Reset form validation errors
        setFormErrors({
            chassisNo: false,
            plateNo: false, 
            chassisProvider: false,
            type: false,
            description: false
        });
    }
    const handleCloseAddChassis = () => {
        setOpen(false);
    };
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleOpenEditChassis = (row) => {
        setEditMode(true);
        setChassisId(row.chassis_id);
        setChassisNo(row.chassis_no);
        setChassisProvider(row.chassis_provider);
        setPlateNo(row.license_plate_no);   
        // setContractType(row.contract_type);
        // setPhone(row.phone_no);
        // setEmail(row.email);
        // setAddress(row.address);
        setType(row.chassis_type);
        setDescription(row.description);
        // Reset form validation errors since we're populating with valid data
        setFormErrors({
            chassisNo: false,
            plateNo: false, 
            chassisProvider: false,
            type: false,
            description: false
        });
        setTimeout(() => {
            setOpen(true);
        }, 0);
    }

    useEffect(() => {
        const loadAutocomplete = () => {
            if (window.google && window.google.maps && window.google.maps.places) {
                const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
                types: ['geocode'],
                });
                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();

                    if (place.geometry) {
                    setAddress(place.formatted_address || '')
                    }
                });
            }
        };
        loadAutocomplete();
    }, [open, editMode]);

    const validateEmail = (value) => {
        const re = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@\"]+\.)+[^<>()[\]\\.,;:\s@\"]{2,})$/i;
        return re.test(String(value).toLowerCase());
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setEmailError(value.length > 0 && !validateEmail(value));
    };

    const handleMenuOpen = (event, row) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const openConfirmDialog = (action, row) => {
        handleMenuClose();
        setConfirmAction(action);
        setSelectedRow(row);
        setActionReason('');
        setIsReasonError(false);
        setConfirmDialogOpen(true);
    };

    const handleConfirmClose = () => {
        setConfirmDialogOpen(false);
        setActionReason('');
        setIsReasonError(false);
    };

    const handleConfirmAction = async () => {
        // Validate reason is provided
        if (!actionReason.trim()) {
            setIsReasonError(true);
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const payload = {
                token: token,
                chassis_id: selectedRow.chassis_id,
                reason: actionReason
            };
            
            if (confirmAction === 'block') {
                payload.status = 2;
            } else if (confirmAction === 'unblock') {
                payload.status = 1;
            } else if (confirmAction === 'delete') {
                payload.status = 3;
            }
            
            let url = operationsUrl + '/transport/add_update_chassis';
            
            const response = await makePostRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                fetchChassisData(); // Refresh the list
            } else {
                setMessage(response.message || `Failed to ${confirmAction} chassis`);
                showSnackbar(true);
            }
        } catch (error) {
            console.error(`Error ${confirmAction}ing chassis:`, error);
            setMessage(`An error occurred while ${confirmAction}ing the chassis`);
            showSnackbar(true);
        } finally {
            handleConfirmClose();
        }
    };

    const handleReasonChange = (e) => {
        setActionReason(e.target.value);
        if (e.target.value.trim()) {
            setIsReasonError(false);
        }
    };
    
    const handleSubmit = async() => {
        // Validate required fields
        const errors = {
            chassisNo: !chassisNo.trim(),
            plateNo: !plateNo.trim(),
            chassisProvider: !chassisProvider,
            type: !type
        };
        if(type=="Others"){
            errors.description = !description.trim();
        }
        setFormErrors(errors);
        
        // If any validation errors exist, prevent form submission
        if (Object.values(errors).some(error => error)) {
            setMessage('Please fill in all required fields');
            showSnackbar(true);
            return; // Prevent form submission
        }
        
        console.log('chassisId', chassisId);
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            city_id: cityFilter,
            chassis_no: chassisNo,
            license_plate_no: plateNo,
            chassis_provider: chassisProvider,
            chassis_type: type,
            // description: description,
            // phone_no: phone,
            // email: email,
            // address: address,
            // contract_type: contractType,
        };
        if(type=="Others"){
            payload.description = description;
        }
        
        if(editMode && chassisId!=''){
            payload.chassis_id = chassisId;
        }
        
        try {
            const url = operationsUrl + '/transport/add_update_chassis';
            const response = await makePostRequestToUrl(url, payload);
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                setOpen(false);
                setEditMode(false);
                fetchChassisData();
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
            showSnackbar(true);
        }
        
    };

    const fetchVendorsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_truck_vendors';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setVendors(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    //export csv
    const formatDataForCSV = (data) => {
        return data ? (data.map((item) => ({
            ...item
        }))) : '';
    };
    const headers = [
        { label: 'Chassis ID', key: 'chassis_id' },
        { label: 'Chassis No', key: 'chassis_no' },
        { label: 'Chassis Provider Id', key: 'chassis_provider' },
        { label: 'Chassis Provider Name', key: 'name' },
        { label: 'Plat No', key: 'license_plate_no' },
        { label: 'Type', key: 'chassis_type' },
        { label: 'Description', key: 'description' }
    ];
    
    //import csv
    const requiredColumns = ['chassis_no', 'chassis_provider', 'license_plate_no', 'chassis_type'];
    
    // Function to download template CSV file
    const downloadCSVTemplate = () => {
        const headers = ['chassis_no', 'chassis_provider', 'license_plate_no', 'chassis_type', 'description'];
        const csvContent = headers.join(',') + '\n' + 'ABC123,Trucker ID,MH01AB1234,Container,Sample description';
        
        // Create a blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Chassis_Template.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const alternativeColumns = {
        'chassis_no': ['Chassis No', 'chassis_no', 'CHASSIS_NO', 'Chassis_No'],
        'chassis_provider': ['Chassis Provider Id', 'chassis_provider', 'CHASSIS_PROVIDER', 'Chassis_Provider'],
        'license_plate_no': ['Plat No', 'license_plate_no', 'LICENSE_PLATE_NO', 'License_Plate_No'],
        'chassis_type': ['Type', 'chassis_type', 'CHASSIS_TYPE', 'Chassis_Type'],
        'description': ['Description', 'description', 'DESCRIPTION', 'Description']
    };

    // Handle CSV import
    const handleImportCSV = (event) => {
        const file = event.target.files[0];
        if (!file) {
            setMessage('No file selected');
            showSnackbar(true);
            return;
        }
        
        console.log('File selected for import:', file.name, 'Size:', file.size, 'Type:', file.type);
        
        // Use the imported handleImportCSVWithCaseInsensitive function
        handleImportCSVWithCaseInsensitive(
            file,
            // Success callback
            async (data, headers) => {
                try {
                    if (!data || data.length === 0) {
                        setMessage('CSV file contains no data');
                        showSnackbar(true);
                        return;
                    }
                    
                    // Process the import using the new shared function
                    const result = await processLocationImport(data);
                    
                    // Display result message
                    setMessage(result.message);
                    showSnackbar(true);
                    
                    // Refresh data if successful
                    if (result.success) {
                        fetchChassisData();
                    }
                    
                    // Reset file input
                    event.target.value = '';
                } catch (error) {
                    console.error('Error processing imported data:', error);
                    setMessage('Error processing imported data');
                    showSnackbar(true);
                    event.target.value = '';
                }
            },
            // Error callback
            (error) => {
                console.error('CSV import error:', error);
                let errorMessage = 'Error importing CSV file';
                
                // If we have specific missing columns info
                if (error.missingColumns) {
                    errorMessage = `CSV is missing required columns: ${error.missingColumns.join(', ')}`;
                    // Show template download button in snackbar
                    setShowTemplateButton(true);
                } else if (typeof error === 'string') {
                    errorMessage = error;
                    setShowTemplateButton(false);
                } else if (error.message) {
                    errorMessage = error.message;
                    setShowTemplateButton(false);
                }
                
                setMessage(errorMessage);
                showSnackbar(true);
                event.target.value = '';
            },
            requiredColumns,
            alternativeColumns
        );
    };
    
    // Process imported location data using the shared processBulkImport function
    const processLocationImport = async (data) => {
        const token = localStorage.getItem('token');
        const url = operationsUrl + '/transport/add_bulk_chassis';
        
        // Map function to convert CSV data to the expected API format
        const mapLocationData = (item) => {
            // Create location object from CSV data
            const locationData = {
                city_id: cityFilter,
                chassis_no: item.chassis_no || item['Chassis No'] || '',
                chassis_provider: item.chassis_provider || item['Chassis Provider Id'] || '',
                license_plate_no: item.license_plate_no || item['Plat No'] || '',
                chassis_type: item.chassis_type || item['Type'] || '',
                description: item.description || item['Description'] || '--'
            };
            
            // Return null for invalid entries (will be filtered out)
            if (!locationData.chassis_no || !locationData.chassis_provider || !locationData.license_plate_no || !locationData.chassis_type) {
                console.warn('Skipping invalid chassis:', item);
                return null;
            }
            
            return locationData;
        };
        
        // Use the shared processBulkImport function
        return await processBulkImport(data, token, url, 'chassis', mapLocationData);
    };
    
    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Chassis
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '3%' }}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddChassis}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Chassis
                    </Button>
                </Grid2>

                <Grid2 item sx={{ marginLeft: "auto", display: 'flex', alignItems: 'center', gap: 2 }}>
                    <input
                        type="file"
                        accept=".csv, .numbers"
                        ref={fileInputRef}
                        onChange={handleImportCSV}
                        style={{ display: 'none' }}
                    />

                    <Button
                        variant="outlined"
                        onClick={downloadCSVTemplate}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Sample CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Sample CSV</span>
                    </Button>

                    <Button
                        variant="outlined"
                        onClick={() => fileInputRef.current.click()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Import CSV</span>
                    </Button>

                    <Button
                        variant="outlined"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <CSVLink
                            data={allData}
                            headers={headers}
                            filename={"Chassis Data.csv"}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                textDecoration: 'none',
                                color: 'inherit',
                                width: '100%',
                                justifyContent: 'center',
                            }}
                        >
                            <span style={{ fontWeight: 500, fontSize: 16 }}>Export CSV</span>
                            <img src={exportCSVIcon} alt="Export CSV" style={{ width: 18, height: 18, marginLeft: 4, marginTop: 2 }} />
                        </CSVLink>
                    </Button>
                </Grid2>
            </Grid2>

            {/* Sidebar for AddClient */}
            <div
                style={{
                    position: 'fixed', top: 65,
                    right: open ? 0 : '-100%', height: '100%', width: '50%', backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out', zIndex: 1000,
                    overflowY: 'auto', padding: 20
                }}
            >
                <Box onClose={handleCloseAddChassis} editMode={editMode}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        {/* Close Button Outside the Card */}
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseAddChassis}
                            style={{
                                position: 'absolute',
                                top: '-15px', // Position it above the Paper component
                                left: '1px',
                                color: '#333',
                                zIndex: 10,
                            }}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Paper elevation={3}
                            style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                            <Typography style={{ marginBottom: '20px', fontWeight: '500', fontSize:'24px' }}>
                                {editMode ? 'Edit Chassis' : 'Add Chassis'}
                            </Typography>

                            <Grid container spacing={2}>

                                <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Chassis Number<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.chassisNo && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Chassis Number is required</Typography>}
                                    <TextField sx={{marginTop:'1%'}} placeholder="Chassis Number" fullWidth variant="outlined"
                                        value={chassisNo} 
                                        onChange={(e) => {
                                            setChassisNo(e.target.value);
                                            setFormErrors({...formErrors, chassisNo: !e.target.value.trim()});
                                        }} 
                                        type="text"
                                        error={formErrors.chassisNo}
                                        InputProps={{
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF'
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Chassis Provider<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.chassisProvider && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Chassis Provider is required</Typography>}
                                    <FormControl fullWidth sx={{ marginTop: '1%' }}>
                                        <Select
                                            value={chassisProvider}
                                            onChange={(e) => {
                                                setChassisProvider(e.target.value);
                                                setFormErrors({...formErrors, chassisProvider: !e.target.value});
                                            }}
                                            error={formErrors.chassisProvider}
                                            displayEmpty
                                            variant="outlined"
                                            sx={{
                                                height: '52px',
                                                borderRadius: '12px',
                                                fontSize: '16px',
                                                backgroundColor: '#FFFFFF',
                                            }}
                                            renderValue={(selected) => {
                                                if (!selected) {
                                                    return <span style={{ color: '#888' }}>Select Truck Vendor</span>;
                                                }
                                                return vendors.find(v => v.truck_vendor_id === selected)?.name || selected;
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                <span style={{ color: '#888' }}>Select Truck Vendor</span>
                                            </MenuItem>
                                            {vendors.map((vendor) => (
                                                <MenuItem key={vendor.truck_vendor_id} value={vendor.truck_vendor_id}>
                                                    {vendor.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Chassis License Plate No<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.plateNo && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>License Plate No is required</Typography>}
                                    <TextField sx={{marginTop:'1%'}} placeholder="Chassis License Plate No" fullWidth variant="outlined" type="text"
                                        value={plateNo} 
                                        onChange={(e) => {
                                            setPlateNo(e.target.value);
                                            setFormErrors({...formErrors, plateNo: !e.target.value.trim()});
                                        }}
                                        error={formErrors.plateNo}
                                        InputProps={{
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Chassis Type<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.type && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Chassis Type is required</Typography>}
                                    <Select sx={{marginTop:'2%'}}
                                        value={type} 
                                        fullWidth
                                        error={formErrors.type}
                                        onChange={(e) => {
                                            setType(e.target.value);
                                            setFormErrors({...formErrors, type: !e.target.value});
                                        }}
                                        style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                        {/* {chassisTypes && chassisTypes.map((chassisType) => (
                                            <MenuItem key={chassisType.chassis_type_id} value={chassisType.chassis_type_id}>
                                                {chassisType.name}
                                            </MenuItem>
                                        ))} */}
                                        <MenuItem key="20-Footer" value="20-Footer">20-Footer</MenuItem>
                                        <MenuItem key="40-Footer" value="40-Footer">40-Footer</MenuItem>
                                        <MenuItem key="45-Footer" value="45-Footer">45-Footer</MenuItem>
                                        <MenuItem key="Others" value="Others">Others</MenuItem>
                                    </Select>
                                </Grid>

                                {type=="Others" && <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Description<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.description && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Description is required</Typography>}
                                    <TextField sx={{marginTop:'1%'}} placeholder="Description" fullWidth variant="outlined" type="text"
                                        value={description} 
                                        onChange={(e) => {
                                            setDescription(e.target.value);
                                            setFormErrors({...formErrors, description: !e.target.value.trim()});
                                        }}
                                        error={formErrors.description}
                                        InputProps={{
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid>
                                }
                                
                                {/* <Grid item xs={12} sm={12}>
                                    <Grid2 sx={{border: '1px solid #D1D5DB', borderRadius:'12px', padding:'8px', marginTop:'16px'}}>
                                        <Grid2 sx={{fontSize:'16px', fontWeight:'500', backgroundColor:'#F9F9F9', padding:'8px 14px', borderRadius:'8px'}}>
                                            Contract Type
                                        </Grid2>
                                        <Grid2 container spacing={2} sx={{justifyContent:'space-between', marginTop:'2%', px: 2, py: 3}}>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    row
                                                    aria-label="contract-type"
                                                    name="contract-type"
                                                    value={contractType}
                                                    onChange={(e) => setContractType(e.target.value)}
                                                    sx={{
                                                        width: '100%',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        gap: '30px',
                                                        '& .MuiFormControlLabel-root': {
                                                            flex: 1,
                                                            margin: 0,
                                                            minWidth: '40%',
                                                        }
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value="1" 
                                                        control={
                                                            <Radio sx={{'&.Mui-checked': {color: '#6B7280' }}}/>
                                                        } 
                                                        label={
                                                            <Typography sx={{ color: '#6B7280', fontSize: '14px' }}>
                                                                Lease
                                                            </Typography>
                                                        }
                                                    />
                                                    <FormControlLabel 
                                                        value="2" 
                                                        control={
                                                            <Radio sx={{'&.Mui-checked': {color: '#6B7280'}}}/>
                                                        } 
                                                        label={
                                                            <Typography sx={{ color: '#6B7280', fontSize: '14px' }}>
                                                                Spot Hire
                                                            </Typography>
                                                        }
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid2>
                                    </Grid2>
                                </Grid> */}

                                {/* <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Contact Person<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%'}} placeholder="Contact Person" fullWidth variant="outlined" type="text"
                                        // value={contactPerson} onChange={(e) => setContactPerson(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 }, // Prevent values less than zero
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid> */}

                            </Grid>

                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <Button variant="contained"
                                    onClick={handleSubmit}
                                    sx={{
                                        width: '140px',height: '50px', textTransform: 'none',fontSize: '16px',
                                        backgroundColor: '#0065FF',color: 'white',
                                    }}
                                >
                                    {editMode ? 'Update' : 'Save'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleCloseAddChassis}
                                    sx={{
                                        width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: '#F0F0F0',color: '#B0B0B0'
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Paper>

                    </div>
                </Box>
            </div>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'chassis_id'}
                                    direction={orderBy === 'chassis_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('chassis_id')}
                                >
                                    Chassis ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'chassis_no'}
                                    direction={orderBy === 'chassis_no' ? order : 'asc'}
                                    onClick={() => handleRequestSort('chassis_no')}
                                >
                                    Chassis No
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'name'}
                                    direction={orderBy === 'name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('name')}
                                >
                                    Chassis Provider
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'license_plate_no'}
                                    direction={orderBy === 'license_plate_no' ? order : 'asc'}
                                    onClick={() => handleRequestSort('license_plate_no')}
                                >
                                    Plate No
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'chassis_type'}
                                    direction={orderBy === 'chassis_type' ? order : 'asc'}
                                    onClick={() => handleRequestSort('chassis_type')}
                                >
                                    Type
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">Actions</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.map((row) => {

                            return(
                                <TableRow key={row.chassis_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.chassis_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.chassis_no}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.license_plate_no}</Typography></TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.phone_no}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.email}</Typography></TableCell> */}
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.chassis_type}</Typography></TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.contract_type}</Typography></TableCell> */}
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.address}</Typography></TableCell> */}
                                    <TableCell align="center" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditChassis(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}
                                        >
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                        </Button>

                                        <IconButton
                                            aria-label="more options" 
                                            size="small"
                                            onClick={(e) => handleMenuOpen(e, row)}
                                            sx={{ marginLeft: '4px' }}
                                        >
                                            {/* <MoreVertIcon /> */}
                                            <img src={threeDots} alt="threeDots"/>
                                        </IconButton>
                                        
                                        <Menu
                                            anchorEl={menuAnchorEl}
                                            open={Boolean(menuAnchorEl) && selectedRow?.tms_client_id === row.tms_client_id}
                                            onClose={handleMenuClose}
                                            PaperProps={{
                                                elevation: 3,
                                                sx: {
                                                    borderRadius: '8px',
                                                    minWidth: '160px',
                                                    padding: '4px 0',
                                                    overflow: 'visible',
                                                    '&:before': {
                                                        content: '""',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 14,
                                                        width: 10,
                                                        height: 10,
                                                        bgcolor: 'background.paper',
                                                        transform: 'translateY(-50%) rotate(45deg)',
                                                        zIndex: 0,
                                                    },
                                                },
                                            }}
                                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                        >
                                            <MenuItem onClick={() => openConfirmDialog(row.status === 2 ? 'unblock' : 'block', row)} sx={{ py: 1 }}>
                                            <ListItemText primary={row.status === 2 ? "Unblock" : "Block"} sx={{ color: '#6B7280' }} />
                                                <ListItemIcon>
                                                    <img src={BlockImg} alt="block"/>
                                                </ListItemIcon>
                                            </MenuItem>
                                            <MenuItem onClick={() => openConfirmDialog('delete', row)} sx={{ py: 1 }}>
                                            <ListItemText primary="Delete" sx={{ color: '#6B7280' }} />
                                                <ListItemIcon>
                                                    <img src={deleteImg} alt="delete"/>
                                                </ListItemIcon>
                                            </MenuItem>
                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
            {/* Confirmation Dialog for Block/Delete */}
            <Dialog
                open={confirmDialogOpen}
                onClose={handleConfirmClose}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        padding: '8px',
                        maxWidth: '500px',
                        width: '100%'
                    }
                }}
            >
                <DialogTitle id="confirm-dialog-title" sx={{ fontWeight: '600', fontSize: '20px' }}>
                    {confirmAction === 'block' ? 'Block Chassis' : 
                     confirmAction === 'unblock' ? 'Unblock Chassis' : 'Delete Chassis'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description" sx={{ color: '#4B5563', mb: 2 }}>
                        Are you sure you want to {confirmAction} this chassis? Please provide a reason.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        label="Reason"
                        type="text"
                        fullWidth
                        value={actionReason}
                        onChange={handleReasonChange}
                        error={isReasonError}
                        helperText={isReasonError ? "Please provide a reason" : ""}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                            }
                        }}
                        multiline
                        rows={3}
                    />
                </DialogContent>
                <DialogActions sx={{ padding: '16px' }}>
                    <Button 
                        onClick={handleConfirmClose} 
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: '#F0F0F0', 
                            color: '#6B7280',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { backgroundColor: '#E0E0E0' }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleConfirmAction} 
                        autoFocus
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: confirmAction === 'delete' ? '#EF4444' : 
                                             confirmAction === 'block' ? '#F59E0B' : '#22C55E',
                            color: 'white',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { 
                                backgroundColor: confirmAction === 'delete' ? '#DC2626' : 
                                                 confirmAction === 'block' ? '#D97706' : '#16A34A'
                            }
                        }}
                    >
                        {confirmAction === 'block' ? 'Block' : 
                         confirmAction === 'unblock' ? 'Unblock' : 'Delete'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Chassis;